import {GenericEntity} from "../models/generic-entity.model";
import {SimpleEntity} from "../models/simple-entity.model";


export default class EntityUtil {

  public static toSimple<E extends GenericEntity>(entity: E): SimpleEntity {
    let simple = new SimpleEntity();
    simple.id = entity.id;
    simple.firm = entity.firm;
    simple.version = entity.version;
    simple.name = entity["name"];
    return simple;
  }

}
